import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgRefresh',
})
export default class CmgRefresh extends Vue {
  get refreshIconUrl(): string {
    return this.$appStore.state.cms.images.icons.refreshRed.default;
  }

  onRefresh(): void {
    this.$emit('refresh');
  }
}
